import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Activity, Flame } from 'lucide-react';
export function Ritual() {
  const [selectedPulse, setSelectedPulse] = useState<string>('same');
  const selectPulse = (option: string) => {
    setSelectedPulse(option);
  };
  return <section className="py-24 bg-black text-white overflow-hidden" data-id="element-215">
      <div className="container mx-auto px-4" data-id="element-216">
        <div className="text-center mb-20" data-id="element-217">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-218">The Ritual</h2>
          <p className="text-xl text-gray-400" data-id="element-219">
            Chat in FlingLink or on your socials. Your choice. Just 2 minutes a
            day.
          </p>
        </div>

        <div className="space-y-24" data-id="element-220">
          {/* Spark */}
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-221">
            <div className="flex-1 text-center md:text-right order-2 md:order-1" data-id="element-222">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500/20 text-yellow-500 mb-4" data-id="element-223">
                <Sparkles className="w-6 h-6" data-id="element-224" />
              </div>
              <h3 className="text-3xl font-bold mb-4" data-id="element-225">Spark</h3>
              <p className="text-gray-400 text-lg" data-id="element-226">
                One question a day. Answer it to unlock theirs. Keeps the convo
                fresh without the "hey wyd" loop.
              </p>
            </div>
            <div className="flex-1 order-1 md:order-2" data-id="element-227">
              <motion.div whileHover={{
              scale: 1.05
            }} className="bg-gray-900 border border-gray-800 p-6 rounded-2xl max-w-sm mx-auto" data-id="element-228">
                <div className="text-xs text-gray-500 mb-2 uppercase tracking-wider" data-id="element-229">
                  Today's Spark
                </div>
                <p className="text-lg font-medium" data-id="element-230">
                  "What's a movie you've seen more than 10 times?"
                </p>
                <div className="mt-4 flex gap-2" data-id="element-231">
                  <div className="h-10 flex-1 bg-gray-800 rounded-lg animate-pulse" data-id="element-232"></div>
                </div>
              </motion.div>
            </div>
          </div>

          {/* Pulse */}
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-233">
            <div className="flex-1" data-id="element-234">
              <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl max-w-sm mx-auto flex justify-between items-center" data-id="element-235">
                <button onClick={() => selectPulse('less')} className="text-center transition-all" data-id="element-236">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl mb-2 cursor-pointer transition-all ${selectedPulse === 'less' ? 'bg-red-500/20 ring-2 ring-red-500' : 'bg-gray-800 hover:bg-red-500/20'}`} data-id="element-237">
                    📉
                  </div>
                  <span className={`text-xs ${selectedPulse === 'less' ? 'text-red-400 font-bold' : 'text-gray-500'}`} data-id="element-238">
                    Less
                  </span>
                </button>
                <button onClick={() => selectPulse('same')} className="text-center transition-all" data-id="element-239">
                  <div className={`w-16 h-16 rounded-full flex items-center justify-center text-3xl mb-2 cursor-pointer transition-all ${selectedPulse === 'same' ? 'ring-2 ring-blue-500 bg-blue-500/20' : 'bg-gray-800 hover:bg-blue-500/20'}`} style={{
                  borderColor: selectedPulse === 'same' ? '#3b82f6' : 'transparent'
                }} data-id="element-240">
                    😌
                  </div>
                  <span className={`text-xs ${selectedPulse === 'same' ? 'text-blue-400 font-bold' : 'text-gray-500'}`} data-id="element-241">
                    Same
                  </span>
                </button>
                <button onClick={() => selectPulse('more')} className="text-center transition-all" data-id="element-242">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl mb-2 cursor-pointer transition-all ${selectedPulse === 'more' ? 'bg-green-500/20 ring-2 ring-green-500' : 'bg-gray-800 hover:bg-green-500/20'}`} data-id="element-243">
                    📈
                  </div>
                  <span className={`text-xs ${selectedPulse === 'more' ? 'text-green-400 font-bold' : 'text-gray-500'}`} data-id="element-244">
                    More
                  </span>
                </button>
              </div>
            </div>
            <div className="flex-1 text-center md:text-left" data-id="element-245">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-500/20 text-blue-500 mb-4" data-id="element-246">
                <Activity className="w-6 h-6" data-id="element-247" />
              </div>
              <h3 className="text-3xl font-bold mb-4" data-id="element-248">Pulse Check</h3>
              <p className="text-gray-400 text-lg" data-id="element-249">
                Private by default. Signal how you're feeling (More / Same /
                Less) without the drama.
              </p>
            </div>
          </div>

          {/* Streak */}
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-250">
            <div className="flex-1 text-center md:text-right order-2 md:order-1" data-id="element-251">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-orange-500/20 text-orange-500 mb-4" data-id="element-252">
                <Flame className="w-6 h-6" data-id="element-253" />
              </div>
              <h3 className="text-3xl font-bold mb-4" data-id="element-254">Streak</h3>
              <p className="text-gray-400 text-lg" data-id="element-255">
                Only counts if you both do it. Includes a Grace Save because
                life happens.
              </p>
            </div>
            <div className="flex-1 order-1 md:order-2 flex justify-center" data-id="element-256">
              <div className="relative w-40 h-40" data-id="element-257">
                <svg className="w-full h-full transform -rotate-90" data-id="element-258">
                  <circle cx="80" cy="80" r="70" stroke="currentColor" strokeWidth="10" fill="transparent" className="text-gray-800" data-id="element-259" />
                  <motion.circle cx="80" cy="80" r="70" stroke="currentColor" strokeWidth="10" fill="transparent" className="text-orange-500" strokeDasharray="440" strokeDashoffset="440" whileInView={{
                  strokeDashoffset: 100
                }} transition={{
                  duration: 2,
                  ease: 'easeOut'
                }} data-id="element-260" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-261">
                  <span className="text-4xl font-bold" data-id="element-262">5</span>
                  <span className="text-sm text-gray-500" data-id="element-263">DAYS</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}